module.exports = __webpack_public_path__ + "static/media/true-icon.bef0028e.png";